import React from 'react';
import moment from 'moment';
import { Checkbox } from '@material-ui/core';
import { DateRow, SearchAndFilter, TextRow, TextToolTip, DocumentSettings } from 'components';
import { ACCOUNT_ENUMS_FOR_DRAW, Images, PermissionsList, RolePermission } from 'utils';

const label = { inputProps: { 'aria-label': 'Color switch demo' } };

export const resourceTabsLabels = [
  { label: 'Files' },
  RolePermission([PermissionsList.MANAGE_RESOURCE?.code]) &&
  { label: 'Access' },
];

export const accessHead = (handleSelect, fullList, selected, disabled) => {
  return [
    { name: 'adminFullName', title: 'User', custom: false },
    { name: 'userType', title: 'User Type', custom: false },
    {
      renderView:
        <div>
          <div className='flex-align-center' style={{ gap: 8, marginBottom: '-4px' }}>
            <TextToolTip
              content='Apply to all'
              showTooltip
              placement='top'
              text={
                <Checkbox
                  {...label}
                  onClick={(e) => handleSelect(e, 'upload', 'all')}
                  name={'checkBox'}
                  style={{ padding: 0, color: '#347AF0', opacity: disabled ? 0.5 : 1 }}
                  disabled={disabled}
                  checked={fullList?.length === selected?.upload?.length}
                />
              }
              wrapperStyles={{
                width: 'fit-content',
              }}
            />

            <p>Upload</p>
          </div>
          <SearchAndFilter item={{ custom: false, name: 'upload', disabled: true }} />
        </div>,
    },
    {
      renderView:
        <div>
          <div className='flex-align-center' style={{ gap: 8, marginBottom: '-4px' }}>
            <TextToolTip
              content='Apply to all'
              showTooltip
              placement='top'
              text={
                <Checkbox
                  {...label}
                  onClick={(e) => handleSelect(e, 'download', 'all')}
                  name={'checkBox'}
                  style={{ padding: 0, color: '#347AF0', opacity: disabled ? 0.5 : 1 }}
                  disabled={disabled}
                  checked={fullList?.length === selected?.download?.length}
                />
              }
              wrapperStyles={{
                width: 'fit-content',
              }}
            />

            <p>Download</p>
          </div>
          <SearchAndFilter item={{ custom: false, name: 'download', disabled: true }} />
        </div>,
    },
    {
      renderView:
        <div>
          <div className='flex-align-center' style={{ gap: 8, marginBottom: '-4px' }}>
            <TextToolTip
              content='Apply to all'
              showTooltip
              placement='top'
              text={
                <Checkbox
                  {...label}
                  onClick={(e) => handleSelect(e, 'delete', 'all')}
                  name={'checkBox'}
                  style={{ padding: 0, color: '#347AF0', opacity: disabled ? 0.5 : 1 }}
                  disabled={disabled}
                  checked={fullList?.length === selected?.delete?.length}
                />
              }
              wrapperStyles={{
                width: 'fit-content',
              }}
            />

            <p>Delete</p>
          </div>
          <SearchAndFilter item={{ custom: false, name: 'delete', disabled: true }} />
        </div>,
    },
    { name: '', title: 'Granted On', custom: false },
  ];
};


export const accessBody = (handleSelect, selected, disabled) => [
  {
    rowText: (item) => <TextRow name={item?.adminFullName} />,
  },

  {
    rowText: (item) => {

      return (
        <TextRow name={ACCOUNT_ENUMS_FOR_DRAW[item?.userType]} />
      )
    },
  },
  {
    rowText: (item) => <Checkbox
      {...label}
      onClick={() => handleSelect(item, 'upload')}
      name={'checkBox'}
      style={{ padding: 0, color: '#347AF0', opacity: disabled ? 0.5 : 1 }}
      disabled={disabled}
      checked={selected?.upload?.includes(item?.adminId)}
    />,
  },
  {
    rowText: (item) => <Checkbox
      {...label}
      onClick={() => handleSelect(item, 'download')}
      name={'checkBox'}
      style={{ padding: 0, color: '#347AF0', opacity: disabled ? 0.5 : 1 }}
      disabled={disabled}
      checked={selected?.download?.includes(item?.adminId)}
    />,
  },
  {
    rowText: (item) => <Checkbox
      {...label}
      onClick={() => handleSelect(item, 'delete')}
      name={'checkBox'}
      style={{ padding: 0, color: '#347AF0', opacity: disabled ? 0.5 : 1 }}
      disabled={disabled}
      checked={selected?.delete?.includes(item?.adminId)}
    />,
  },
  {
    rowText: (item) => (item?.grantedOn && item?.grantedBy) ?
      <div>
        <DateRow date={item?.grantedOn} />
        <TextRow name={`${moment(item?.grantedOn).format('hh:mm a')} by ${item?.grantedBy}`} />
      </div>
      :
      'N/A',
  },
];

export const ACCESS_ACTION_TYPE = 'GET_RESOURCE_ACCESS';

const fileType = (type) => {
  switch (type) {
    case 'png':
      return Images.PNgSvg;
    case 'jpg':
      return Images.JPEgSVG;
    case 'jpeg':
      return Images.JPEgSVG;
    case 'pdf':
      return Images.PDfSvg;
    default:
      return Images.FileTypeSvg;
  }
};


export const resourceFilesHead = (noSearch, userAccess) => {
  const editAccess = RolePermission([PermissionsList.MANAGE_RESOURCE?.code]) || userAccess?.upload;
  const downloadAccess = RolePermission([PermissionsList.MANAGE_RESOURCE?.code]) || userAccess?.download;
  const deleteAccess = RolePermission([PermissionsList.MANAGE_RESOURCE?.code]) || userAccess?.delete;

  return [
    { name: 'name', title: 'Document Name', custom: false, noSearch: noSearch },
    { name: 'description', title: 'Document Description', custom: false, noSearch: noSearch },
    { name: 'date', title: 'Date Uploaded', custom: false, disabled: true, noSearch: noSearch },
    (editAccess || downloadAccess || deleteAccess) &&
    { name: '', title: 'Action', custom: false, disabled: true, width: '50px', noSearch: noSearch },
  ];
};


export const resourceFilesBody = (selectedId, userAccess, handleClickActions, DELETE_ACTION_TYPE) => {
  const editAccess = RolePermission([PermissionsList.MANAGE_RESOURCE?.code]) || userAccess?.upload;
  const downloadAccess = RolePermission([PermissionsList.MANAGE_RESOURCE?.code]) || userAccess?.download;
  const deleteAccess = RolePermission([PermissionsList.MANAGE_RESOURCE?.code]) || userAccess?.delete;

  return [
    {
      rowText: (item) => (
        <div className='align-center' style={{ gap: '16px' }}>
          <div className='doc-type-img-block'>
            <img src={fileType(item?.file?.format)} alt='file type' />
          </div>

          <div className='document-name-size-wrapper'>
            <TextToolTip
              content={item?.name}
              text={item?.name}
              classNameText='doc-type-name'
              onClick={() => {
                if (item?.file?.url) {
                  window.open(item?.file?.url, '_blank');
                }
              }}
            />
          </div>
        </div>
      ),
    },
    {
      rowText: (item) => <TextRow name={item?.description} textWidth={9} />,
    },
    {
      rowText: (item) => <DateRow date={item?.uploadedDate} />,
    },

    (editAccess || downloadAccess || deleteAccess) &&
    {
      rowText: (item) => (
        <DocumentSettings
          document={item}
          handleEdit={editAccess ? () => handleClickActions(item, 'edit') : null}
          handleDeleteDocument={deleteAccess ? () => handleClickActions(item, 'delete') : null}
          deleteAccess
          downloadAccess={downloadAccess}
          viewAccess={downloadAccess}
          deleteDocAction={DELETE_ACTION_TYPE}
        />
      ),
    },
  ];
};

export const resourceFileNotYet = {
  title: 'No Files Uploaded',
  subTitle: 'Upload files to store relevant documents here.',
  image: Images.notFile,
};
